export default __webpack_public_path__ + "static/media/eth_location.89042547.svg";